<template>
 <div class="scence" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <el-row>
        <el-col :span="4">
          <div class="leftPermission" ref="leftPermission">
          <el-aside width="100%" class="left-panel">
            <div class="title-panel">权限分组</div>
            <el-tree
              style="border-right: 1px solid #eee;"
              :data="permissionGroups"
              :expand-on-click-node="false"
              :props="defaultProps"
              :default-expand-all="true"
              :highlight-current="true"
              @node-click="onNodeClick"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>
                  <el-tooltip :content="data.desc || data.name"><span class="menu-label">{{node.label}}</span></el-tooltip>
                </span>
                <span>
                  <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      <i class="el-icon-more el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if="allowsPerm.insert" :command="{comm:'add',data:data,node:node}">添加子分组</el-dropdown-item>
                      <el-dropdown-item v-if="data.groupId > 0 && allowsPerm.update" :command="{comm:'edit',data:data,node:node}">编辑</el-dropdown-item >
                      <el-dropdown-item v-if="data.groupId > 0 && allowsPerm.delete" :command="{comm:'del',data:data,node:node}">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
              </span>
            </el-tree>
          </el-aside>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="rightPermission" ref="rightPermission">
           <div class="select">
              <span class="xzqh">权限名称:</span>
               <div class="selcountry">
                <el-input
                  placeholder="搜索权限名称"
                  v-model="query.searchName"
                  @keyup.enter.native="onLoadData"
                  class="filter-item"
                  style="width: 150px; float:left;"
                  clearable
                  @change="Global.emptyQuery(query.searchName,onLoadData)"
                ></el-input>
               </div>
              <span id="search" @click="onLoadData">查询</span>
              <span v-if="allowsPerm.insert" id="add" @click="onAdd"><span class="add-icon"></span>新增</span>
               <edit-form ref="editForm" :showEdit="showEdit" :current-data="currentPermission" :permissionGroups="permissionGroups" @close="onEditClose"></edit-form>
            </div>
            <div class="permissionsTable" ref="permissionsTable">
            <el-table :data="permissions" border :max-height="height" v-loading="loading"  style="width: 100%">
              <el-table-column type="index" min-width="15" align="center" label="序号"></el-table-column>
              <el-table-column align="center" min-width="60" label="分组名称" prop="permissionGroupName"></el-table-column>
              <el-table-column align="center" min-width="60" label="权限编码" prop="code"></el-table-column>
              <el-table-column align="center" min-width="60" label="权限名称" prop="name"></el-table-column>
              <el-table-column align="center" min-width="100" label="权限描述" prop="desc"></el-table-column>
              <el-table-column align="center" min-width="50" label="操作">
                <template slot-scope="scope">
                  <div class="operation">
                    <span v-if="allowsPerm.update" class="del" @click="onDelete(scope.row)"><span class="del-icon"></span>删除</span>
                    <span v-if="allowsPerm.delete" class="edit" @click="onEdit(scope.row)"><span class="edit-icon"></span>编辑</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :title="diagTitle" :visible.sync="diagShow" width="580px" :close-on-click-modal='false'>
      <el-form ref="groupForm" :rules="rules" :model="currentGroup" label-width="200px">
        <el-form-item label="分组名称" required prop="name">
          <el-input v-model="currentGroup.name" placeholder="输入权限分组名称" style="width: 160px;"></el-input>
        </el-form-item>
        <el-form-item label="上级分组">
          <select-tree
            ref="selTree"
            :onlyLeaf=false
            :valueKey='"groupId"'
            v-model="currentGroup.parentId"
            placeholder="默认为顶层分组"
            :treeProps="defaultProps"
            :data="permissionGroups"
            ></select-tree>
        </el-form-item>
        <el-form-item label="栏目标识(唯一)" required prop="code">
          <el-input v-model="currentGroup.code" placeholder="输入栏目标识" style="width: 160px;"></el-input>
        </el-form-item>
        <el-form-item label="链接地址" required prop="url">
          <el-input v-model="currentGroup.url" placeholder="输入链接地址" style="width: 160px;"></el-input>
        </el-form-item>
        <el-form-item label="状态" required prop="state">
          <el-radio-group v-model="currentGroup.state">
            <el-radio label="Enable">启用</el-radio>
            <el-radio label="Disable">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="图标id">
          <el-input v-model="currentGroup.imgid" placeholder="输入图标id" style="width: 160px;"></el-input>
        </el-form-item>
        <el-form-item label="功能项" prop="functions">
          <!-- <el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox> -->
          <el-checkbox-group :indeterminate="isIndeterminate" v-model="currentGroup.functions" @change="handleCheckedFunctionsChange">
            <el-checkbox v-for="func in functionArr" :label="func.eng" :key="func.eng">{{func.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="分组描述" prop="desc">
          <el-input v-model="currentGroup.desc" placeholder="输入权限分组描述"></el-input>
        </el-form-item>
        <el-form-item label="是否外链地址(在新窗口打开)" prop="isLink">
          <el-radio-group v-model="currentGroup.isLink">
            <el-radio :label='true'>是</el-radio>
            <el-radio :label='false'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="iframe地址" prop="iframeUrl">
          <el-input v-model="currentGroup.iframeUrl" placeholder="请添加iframe地址,多个用;隔开"></el-input>
        </el-form-item>
        <el-form-item label="非菜单栏" prop="isLink">
          <el-radio-group v-model="currentGroup.topColumn">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序字段" prop="sort">
          <el-input v-model="currentGroup.sort" placeholder="输入排序字段(如:1,2,3....)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="diagShow = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </div>
    </el-dialog>
 </div>
</template>

<script>
import accountTypes from '@/store/types/account'
import appTypes from '@/store/types/app'
import { Pager, SelectTree } from '@/components'
import EditForm from './edit.vue'
export default {
  name: 'PermissionIndex',
  components: {
    Pager,
    SelectTree,
    EditForm
  },
  data () {
    return {
      height: 10,
      loading: false,
      showEdit: false,
      diagShow: false,
      diagTitle: '新增分组',
      query: {
        searchName: '',
        permissionGroupId: 0,
        pageIndex: 1,
        pageSize: 20
      },
      defaultProps: {
        label: 'name',
        children: 'children'
      },
      functionArr: [
        { name: '查询', eng: 'search' }, { name: '新增', eng: 'insert' },
        { name: '修改', eng: 'update' }, { name: '删除', eng: 'delete' }
      ],
      isIndeterminate: true,
      total: 0,
      currentGroup: {
        functions: ['search']
      },
      currentPermission: {},
      permissions: [],
      permissionGroups: [],
      rules: {
        name: [
          { required: true, message: '权限分组名称必填' }
        ],
        url: [
          { required: true, message: '链接地址必填' }
        ],
        code: [
          { required: true, message: '栏目标识必填' }
        ],
        state: [
          { required: true, message: '状态必填', trigger: 'change' }
        ],
        functions: [
          { type: 'array', required: true, message: '功能项必填', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    onLoadData () {
      this.loading = true
      this.$store.dispatch(accountTypes.GET_PERMISSIONS, this.query).then(data => {
        this.total = data.total
        this.permissions = data.results
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleCommand (command) {
      if (command.comm === 'add') {
        this.onGroupAdd(command.data)
      }
      if (command.comm === 'edit') {
        this.onGroupEdit(command.data, command.node)
      }
      if (command.comm === 'del') {
        this.onGroupDelete(command.data, command.node)
      }
    },
    loadPermissionGroups () {
      this.$store.dispatch(accountTypes.GET_PERMISSIONGROUPS, { withPermission: false }).then(groups => {
        this.permissionGroups = groups
      })
    },
    onCurrentChange (pageIndex) {
      this.query.pageIndex = pageIndex
      this.onLoadData()
    },
    onSizeChange (pageSize) {
      this.query.pageIndex = 1
      this.query.pagesize = pageSize
      this.onLoadData()
    },
    onAdd () {
      this.$refs.editForm.clearValidate()
      this.currentPermission = { permissionGroupId: this.query.permissionGroupId }
      this.showEdit = true
    },
    onEdit (row) {
      this.$refs.editForm.clearValidate()
      this.currentPermission = Object.assign({}, row)
      this.showEdit = true
    },
    onDelete (row) {
      this.$confirm(`确定要删除授权项 '${row.name}' 吗?`, '确认').then(() => {
        this.loading = true
        this.$store.dispatch(accountTypes.DELETE_PERMISSION, { id: row.id }).then(() => {
          this.loading = false
          this.$notify.success({ title: '成功', message: '删除授权项成功.' })
          this.onLoadData()
        }).catch(() => { this.loading = false })
      }).catch(() => {})
    },
    onEditClose (reload = false) {
      this.showEdit = false
      reload && this.onLoadData()
    },
    onGroupAdd (data) {
      this.diagTitle = '新增分组'
      this.currentGroup = { functions: ['search'], isNew: true, parentId: 0, groupName: '无' }

      if (data) {
        this.currentGroup.parentId = data.groupId
        this.currentGroup.groupName = data.name
      }
      this.diagShow = true
      this.$nextTick(() => {
        this.$refs['groupForm'].clearValidate()
      })
    },
    onGroupEdit (data) {
      // this.currentGroup.functions = data.functions

      this.diagTitle = '编辑分组'
      this.currentGroup = Object.assign({ isNew: false }, data)
      this.diagShow = true
    },
    onGroupDelete (data) {
      this.$confirm(`确定要删除权限分组 '${data.name}' 吗?`, '确认').then(() => {
        this.loading = true
        this.$store.dispatch(accountTypes.DELETE_PERMISSIONGROUP, { id: data.groupId }).then(() => {
          this.loading = false
          this.$notify.success({ title: '成功', message: '删除权限分组成功.' })
          this.loadPermissionGroups()
        }).catch(() => { this.loading = false })
      }).catch(() => {})
    },
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.currentGroup.id = this.currentGroup.groupId
          this.$store.dispatch(accountTypes.SAVE_PERMISSIONGROUP, this.currentGroup).then(() => {
            this.loading = false
            this.diagShow = false
            this.$notify.success({ title: '成功', message: '保存权限分组成功.' })
            this.loadPermissionGroups()
            this.close()

            // this.currentGroup = {}
          })
        }
      })
    },
    onNodeClick (item) {
      this.query.permissionGroupId = item.groupId
      this.onLoadData()
    },
    handleCheckedFunctionsChange () {
      console.log(this.currentGroup.functions)
      let checkedCount = this.currentGroup.functions.length
      this.checkAll = checkedCount === this.functionArr.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.functionArr.length
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.loadPermissionGroups()
    this.onLoadData()
  },
  mounted () {
    this.$store.dispatch(appTypes.SET_BREADCRUMB, {
      type: 'app',
      route: {
        path: '/app/index',
        meta: { title: '应用管理' }
      }
    })
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs.leftPermission.style.height = (contentDiv[0].offsetHeight - 30) + 'px'
      this.$refs.leftPermission.style.overflow = 'auto'
      this.$refs.rightPermission.style.height = (contentDiv[0].offsetHeight - 30) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs.rightPermission.offsetHeight - 15 - selectDiv[0].offsetHeight
    })
  }
}
</script>
<style lang="less" scoped>
.scence {
  width: 100%;
  height: 100%;
  // margin-top: -80px;
  .content{
  padding-top: 15Px;
  padding-bottom: 15Px;
  width: 100%;
  height: 100%;
  .leftPermission{
   width: 96%;
   margin-left: 4%;
  background-color: #fff;
  border-radius: 5px;
  }
  .rightPermission {
  width: 97%;
  margin-left: 2%;
  background-color: #fff;
  border-radius: 5px;
    .select {
        height: 50px;
        width: 100%;
        padding-top:5px;
        padding-bottom: 30px;
        overflow: hidden;
    }
    > .permissionsTable {
       width: 98%;
       margin-left: 1%;
    }
  }
  }
}
.left-panel {
  background-color: #eef1f6;
}
.menu-label{
  width:100px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.title-panel {
  line-height: 30px;
  background-color: #ffffff;
  border-bottom: 1px solid #ddd;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  text-align: center;
  padding: 5px;
}
.scence .el-icon--right{
 margin-left: 0 !important;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
 .add-icon{
    width: 18px;
    height: 17px;
    display: block;
    background-image: url('~@/assets/monitorimg/add.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 5px;
    float: left;
    margin-top: 2px;
  }
  .del-icon{
    .add-icon();
    background-image: url('~@/assets/monitorimg/del.png');
  }
  .edit-icon{
    .add-icon();
    background-image: url('~@/assets/monitorimg/edit.png');
  }
  .save-icon{
    .add-icon();
    background-image: url('~@/assets/monitorimg/save.png');
  }
  #search{
    font-size: 16px;
    padding: 9px 18px;
    background-color: #3d72fb;
    cursor: pointer;
    float: left;
    color: #ffffff;
    border-radius: 3px;
    margin-left: 10px;
    margin-top: 3px;
  }
  #search:hover,#select:hover,#export:hover{
    background-color: #4d8cff;
  }
   #add{
    background-color: #3e81fc;
    font-size: 16px;
    padding: 9px 18px;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 15px;
  }
  .xzqh{
    font-size:16px;
    font-family:Microsoft YaHei UI;
    float: left;
    margin-left: 20px;
    margin-top: 10px;
    margin-right: 10px;
  }
  #add:hover{
      background-color: #4d8cff;
    }
    .add-icon{
    width: 18px;
    height: 17px;
    display: block;
    background-image: url('~@/assets/monitorimg/add.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 5px;
    float: left;
    margin-top: 2px;
  }
  .edit{
    font-size: 16px;
    padding: 9px 8px;
    background-color: #27b6e2;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    margin-top: 3px;
    height: 37px;
  }
  .edit:hover{
      background-color: #12a0cc;
    }
  .del-icon{
    background-image: url('~@/assets/monitorimg/del.png');
  }
  .edit-icon{
    background-image: url('~@/assets/monitorimg/edit.png');
  }
  .save-icon{
    background-image: url('~@/assets/monitorimg/save.png');
  }
  .del{
    background-color: #fda72c;
    font-size: 16px;
    padding: 9px 8px;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    margin-top: 3px;
    height: 37px;
  }
  .del:hover{
      background-color: #f38b04;
    }
  .operation {
   width: 210px;
   margin: 0 auto;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
  /deep/ .el-dialog__title {
    color: #fff;
    margin-left: 85px;
    display: inline-block;
  }
  /deep/ .el-dialog .el-dialog__header {
    background-color: #3e6ffc;
    background-image: url('~@/assets/monitorimg/opentitle.png');
    background-repeat: no-repeat;
    background-position: 18px 28px;
    background-size: 370px 17px;
  }
  /deep/.el-dialog{
    margin-top:5vh!important;
  }
</style>
